import { create } from "zustand";
import { IUserCoupon } from "@/types/user.types";
import selectColorTypeCoupon from "@/components/common/selectColorCoupon";
import { format } from "date-fns";

export const useUserCoupon = create<IUserCoupon>((set) => ({
  data: {
    dynamic: "1",
    name: "",
    design_colors_primary: selectColorTypeCoupon[0].color,
    design_colors_button: selectColorTypeCoupon[0].buttonColor,
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    company: "",
    headline: "",
    description: "",
    sale_badge: "10%",
    coupon_name: "",
    start_date: format(new Date(), "yyyy-MM-dd"),
    address: "",
    longitude: -73.9855426,
    latitude: 40.7579747,
    street: "",
    street_number: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    button: "Shop Now",
    button_url: "",
    barcode_image: "",
    barcode_path: "",
    welcome_screen: "",
    welcome_path: "",
    showUseBarCode: false,
    showMoreAddress: false,
  },
  salesButton: [
    {
      value: "10% OFF",
      icon: "",
    },
    {
      value: "30% OFF",
      icon: "",
    },
    {
      value: "50% OFF",
      icon: "",
    },
    {
      value: "2 FOR 1",
      icon: "",
    },
    {
      value: "SALE",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],
  shopNow: [
    {
      value: "Shop now",
      icon: "",
    },
    {
      value: "Redeem now",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],
  config: {},
  destroyUserCoupon: () => {
    set({
      data: {
        dynamic: "1",
        name: "",
        design_colors_primary: selectColorTypeCoupon[0].color,
        design_colors_button: selectColorTypeCoupon[0].buttonColor,
        image: "",
        image_name: "",
        image_type: "",
        image_path: "",
        company: "",
        headline: "",
        description: "",
        sale_badge: "10%",
        coupon_name: "",
        start_date: format(new Date(), "yyyy-MM-dd"),
        address: "",
        longitude: -73.9855426,
        latitude: 40.7579747,
        street: "",
        street_number: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        button: "Shop Now",
        button_url: "",
        barcode_image: "",
        barcode_path: "",
        welcome_screen: "",
        welcome_path: "",
        showUseBarCode: false,
        showMoreAddress: false,
      },
      salesButton: [
        {
          value: "10% OFF",
          icon: "",
        },
        {
          value: "30% OFF",
          icon: "",
        },
        {
          value: "50% OFF",
          icon: "",
        },
        {
          value: "2 FOR 1",
          icon: "",
        },
        {
          value: "SALE",
          icon: "",
        },
        {
          value: "Custom",
          icon: "/common/edit-icon.svg",
        },
      ],
      shopNow: [
        {
          value: "Shop now",
          icon: "",
        },
        {
          value: "Redeem now",
          icon: "",
        },
        {
          value: "Custom",
          icon: "/common/edit-icon.svg",
        },
      ],
    });
  },
  setUserCoupon: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setShowUseBarCode: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          showUseBarCode: val,
        },
      };
    });
  },
  setUserParams: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setShowMoreAddress: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          showMoreAddress: val,
          address: val ? "" : state.data.address,
        },
      };
    });
  },
  setDeleteKey: (val) =>
    set((state) => {
      delete state.data[val as keyof typeof state.data];

      return { ...state };
    }),
}));
